import {deserializeAs} from "cerialize";
import {Document} from "./document";
import {DocumentSharing} from "../documentSharing";

export  class DocumentsToShare {

  @deserializeAs(Document)
  residence: DocumentSharing [];

  @deserializeAs(Document)
  logement: DocumentSharing[];

  @deserializeAs(Document)
  mesDocuments: DocumentSharing[];
}
